// User page reducer constants
const SET_USER_PAGE_STATUS = "SET_USER_PAGE_STATUS";
const SET_USER_LOGGED_IN = "SET_USER_LOGGED_IN";
const SET_INIT_DATA = "SET_INIT_DATA";
// Assigned tasks reducer constants
const SET_ASSIGNED_TASKS = "SET_ASSIGNED_TASKS";
const SET_ASSIGNED_TASKS_LOADING = "SET_ASSIGNED_TASKS_LOADING";
//Assignable tasks reducer constants
const SET_ASSIGNABLE_TASKS = "SET_ASSIGNABLE_TASKS";
const SET_ASSIGNABLE_TASKS_LOADING = "SET_ASSIGNABLE_TASKS_LOADING";
const REMOVE_ASSIGNABLE_TASK = "REMOVE_ASSIGNABLE_TASK";
//User page task reducer constants
const SET_USER_PAGE_TASK_DATA = "SET_USER_PAGE_TASK_DATA";
const SET_USER_PAGE_TASK_LOADING = "SET_USER_PAGE_TASK_LOADING";
const UPDATE_USER_PAGE_TASK_DATA = "UPDATE_USER_PAGE_TASK_DATA";
const UPDATE_USER_PAGE_TASK_STAGE = "UPDATE_USER_PAGE_TASK_STAGE";
const UPDATE_USER_PAGE_TASK_DONE = "UPDATE_USER_PAGE_TASK_DONE";
//User page notifications reducer constants
const SET_USER_PAGE_NOTIFICATIONS_NEW_COMMENTS = "SET_USER_PAGE_NOTIFICATIONS_NEW_COMMENTS";
const CHANGE_USER_PAGE_NOTIFICATIONS_LOADING = "CHANGE_USER_PAGE_NOTIFICATIONS_LOADING";
// User page user reducer constants
const SET_USER_PAGE_USER_DATA = "SET_USER_PAGE_USER_DATA";
const SET_USER_PAGE_USER_LOADING = "SET_USER_PAGE_USER_LOADING";
// Custom feilds
const UPDATE_CUSTOM_FIELD_VALUE = "UPDATE_CUSTOM_FIELD_VALUE";
//Time
const SESSION_EXPIRE_NOTIFICATION_TRESHOLD = 30; // in minutes
// Intervals
const SESSION_NOTIFICATION_CHECK_INTERVAL = 10 * 60 * 1000; // 10 minutes in milliseconds
const CHECK_NEW_COMMENTS_INTERVAL = 60 * 2000; // 2 minute in milliseconds
export { CHANGE_USER_PAGE_NOTIFICATIONS_LOADING, CHECK_NEW_COMMENTS_INTERVAL, REMOVE_ASSIGNABLE_TASK, SESSION_EXPIRE_NOTIFICATION_TRESHOLD, SESSION_NOTIFICATION_CHECK_INTERVAL, SET_ASSIGNABLE_TASKS, SET_ASSIGNABLE_TASKS_LOADING, SET_ASSIGNED_TASKS, SET_ASSIGNED_TASKS_LOADING, SET_INIT_DATA, SET_USER_LOGGED_IN, SET_USER_PAGE_NOTIFICATIONS_NEW_COMMENTS, SET_USER_PAGE_STATUS, SET_USER_PAGE_TASK_DATA, SET_USER_PAGE_TASK_LOADING, SET_USER_PAGE_USER_DATA, SET_USER_PAGE_USER_LOADING, UPDATE_CUSTOM_FIELD_VALUE, UPDATE_USER_PAGE_TASK_DATA, UPDATE_USER_PAGE_TASK_DONE, UPDATE_USER_PAGE_TASK_STAGE, };
